import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          insertion: {
            '{}': {
              inputs: {
                '{}': {
                  records: {
                    '[]': [
                      {
                        '{}': {
                          values: {
                            '{}': {
                              '!id': {
                                '@$': 'activityId',
                              },
                              '!name': {
                                '@$': 'activityName',
                              },
                              '!code': {
                                '@$': 'activityName',
                              },
                              '!descr': {
                                '@$': 'activityDescr',
                              },
                              '!always_recommend': {
                                '??': [
                                  {
                                    '@$': 'activityAlwaysRecommend',
                                  },
                                  false,
                                ],
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              modelId: 'ent:!subaward_monitor_acts:!activity',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
